const stylesDesktop = {
  menuContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "linear-gradient(180deg, rgba(70, 70, 70, 0.3) 0%, rgba(70, 70, 70, 0.1) 100%)",
    padding: "clamp(0.6rem, 1.5vw, 0.78125rem) clamp(3rem, 5vw, 4.40625rem)", 
    marginLeft: "clamp(1.5rem, 3vw, 2.7rem)", 
    border: "0.5px solid rgba(100, 100, 100, 0.5)",
    borderRadius: "50px",
    maxWidth: '1440px',
  },

  menu: {
    display: "flex",
    listStyle: "none",
    margin: 0,
    padding: 0,
    gap: "clamp(3rem, 6vw, 8.03125rem)", 
  },

  linkBase: {
    color: "#FFF",
    textDecoration: "none",
    fontSize: "clamp(0.8rem, 1.2vw, 1rem)", 
    transition: "color 0.3s",
    padding: "clamp(0.3rem, 0.6vw, 0.4rem) clamp(0.5rem, 1vw, 0.6rem)", 
    cursor: "pointer",
  },
};

export default stylesDesktop;
